import { useQuery } from "@tanstack/react-query";
import axios from "axios";

import { useSession } from "@/services/auth";

export interface OrderPaymentHistoryItem {
  id: string;
  amountCents: number;
  currency: string;
  status: string;
  method: string;
  transactionType: "DEBIT" | "CREDIT";
  parentPaymentId: string | null;
  stripeReceiptUrl: string | null;
  referenceNumber: string | null;
  notes: string | null;
  metadata: Record<string, unknown> | null;
  failureReason: string | null;
  createdAt: string;
  receipts: Array<{
    id: string;
    receiptNumber: string;
    type: string;
    fileUrl: string;
    createdAt: string;
  }>;
}

export function useOrderPayments(orderId?: string) {
  const { token } = useSession();
  return useQuery({
    queryKey: ["orderPayments", orderId],
    queryFn: async () => {
      const response = await axios.get<{
        success: true;
        data: OrderPaymentHistoryItem[];
      }>(
        `${import.meta.env.VITE_API_URL}/api/customer/orders/${orderId}/payments`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      return response.data.data;
    },
    enabled: Boolean(token && orderId),
  });
}
